export enum ComponentLocation {
  AuthenticationPage = 'authentication_page',
  AuthenticationModal = 'authentication_modal',
}

export enum ErrorReason {
  ErrorBoundary = 'error_boundary',
  UnresolvedComponent = 'unresolved_component',
}
